import React from 'react';

import { useClaim } from '~/components/ClaimContainer';
import { InvolvedPersonHoverInfo } from '~/components/InvolvedPersonHoverInfo';
import { InvolvedPropertyHoverInfo } from '~/components/InvolvedPropertyHoverInfo';
import Divider from '~/components/ui/atoms/Divider';
import type { ContactFullModel } from '~/server_shared/swagger/data-contracts';

interface ContactInvolvedLinksPropsType {
  contact: ContactFullModel;
}

// expect errors because migrated claim to generated type and need to fix it later
const InvolvedLinks: React.FC<ContactInvolvedLinksPropsType> = ({ contact }) => {
  const { claim } = useClaim({ claimRequired: true });

  const linkComponents = [];
  if (contact.role === 'insurer') {
    linkComponents.push(
      // @ts-expect-error migrated claim to generated type and need to fix it later
      ...claim.incident.involved_properties
        // @ts-expect-error migrated claim to generated type and need to fix it later
        .filter((involvedProperty) => involvedProperty.insurer_contact_id === contact.id)
        // @ts-expect-error migrated claim to generated type and need to fix it later
        .map((involvedProperty) => (
          <div key={involvedProperty.id}>
            <InvolvedPropertyHoverInfo
              claimId={claim.id}
              involvedProperty={involvedProperty}
              textualOwnerButton
              textualExtraInfo={
                involvedProperty.insurer_reference_number ? `Ref #: ${involvedProperty.insurer_reference_number}` : ''
              }
            />
          </div>
        ))
    );
  }

  if (contact.role === 'attorney') {
    linkComponents.push(
      // @ts-expect-error migrated claim to generated type and need to fix it later
      ...claim.incident.involved_properties
        // @ts-expect-error migrated claim to generated type and need to fix it later
        .filter((involvedProperty) => involvedProperty.attorney_contact_id === contact.id)
        // @ts-expect-error migrated claim to generated type and need to fix it later
        .map((involvedProperty) => (
          <div key={involvedProperty.id}>
            <InvolvedPropertyHoverInfo
              claimId={claim.id}
              involvedProperty={involvedProperty}
              textualOwnerButton
              textualExtraInfo={
                involvedProperty.attorney_reference_number ? `Ref #: ${involvedProperty.attorney_reference_number}` : ''
              }
            />
          </div>
        ))
    );
    linkComponents.push(
      // @ts-expect-error migrated claim to generated type and need to fix it later
      ...claim.incident.involved_persons
        // @ts-expect-error migrated claim to generated type and need to fix it later
        .filter((involvedPerson) => involvedPerson.attorney_contact_id === contact.id)
        // @ts-expect-error migrated claim to generated type and need to fix it later
        .map((involvedPerson) => (
          <div key={involvedPerson.id}>
            <InvolvedPersonHoverInfo
              claimId={claim.id}
              involvedPerson={involvedPerson}
              textualButton
              textualExtraInfo={
                involvedPerson.attorney_reference_number ? `Ref #: ${involvedPerson.attorney_reference_number}` : ''
              }
            />
          </div>
        ))
    );
  }

  linkComponents.push(
    // @ts-expect-error migrated claim to generated type and need to fix it later
    ...claim.incident.involved_properties
      // @ts-expect-error migrated claim to generated type and need to fix it later
      .filter((involvedProperty) => involvedProperty.owner_contact_id === contact.id)
      // @ts-expect-error migrated claim to generated type and need to fix it later
      .map((involvedProperty) => (
        <InvolvedPropertyHoverInfo
          key={involvedProperty.id}
          claimId={claim.id}
          involvedProperty={involvedProperty}
          textualOwnerButton
        />
      ))
  );
  linkComponents.push(
    // @ts-expect-error migrated claim to generated type and need to fix it later
    ...claim.incident.involved_persons
      // @ts-expect-error migrated claim to generated type and need to fix it later
      .filter((involvedPerson) => involvedPerson.contact_id === contact.id)
      // @ts-expect-error migrated claim to generated type and need to fix it later
      .map((involvedPerson) => (
        <InvolvedPersonHoverInfo
          key={involvedPerson.id}
          claimId={claim.id}
          involvedPerson={involvedPerson}
          textualButton
        />
      ))
  );

  return (
    <div className="flex">
      {linkComponents.map((link, index) => (
        <>
          {link}
          {index < linkComponents.length - 1 ? (
            <Divider orientation="vertical" variant="middle" flexItem className="mx-8" />
          ) : null}
        </>
      ))}
    </div>
  );
};

export default InvolvedLinks;
